module.exports = __webpack_public_path__ + "media/images/icon__plus-4e23dc76204c35bcfdb6781990430c66.png";